module.exports = __webpack_public_path__ + "static/media/07.1bed832b.webp";